import { motion, AnimatePresence } from 'framer-motion';
import { useChatApi } from '../Services/ChatApiProvider';
import assistantAvatar1 from '../media/assist1.jpg';
import assistantAvatar2 from '../media/assist2.jpg';

const ChatAvatars = ({ isChatActive, chatType }) => {
  // normalize raw base64 → data URL
  const toDataUrl = (s) => {
    if (!s || typeof s !== 'string') return null;
    const compact = s.trim().replace(/\s+/g, '');
    if (!compact || compact === 'null' || compact === 'undefined') return null;
    return compact.startsWith('data:image/') ? compact : `data:image/png;base64,${compact}`;
  };

  const { channelSettings } = useChatApi();
  const aiAssistantImage = toDataUrl(channelSettings?.AIassistantImage);
  const liveAssistantImage = toDataUrl(channelSettings?.liveAssistantImage);
  const liveAvatarSrc = liveAssistantImage ? liveAssistantImage : assistantAvatar2;

  return (
    <AnimatePresence>
      {!isChatActive && (
        <motion.div
          className="chat-avatars"
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        >
          <div className="avatar avatar1">
            <img src={assistantAvatar1} alt="Assistant 1" />
          </div>
          <div className="avatar avatar-next">
            <img src={liveAvatarSrc} alt="Assistant 2" />
          </div>
          <div
            className={`avatar avatar-next bot ${aiAssistantImage ? 'has-ai-avatar' : ''}`}
            style={aiAssistantImage ? { backgroundImage: `url(${aiAssistantImage})` } : undefined}
          ></div>
        </motion.div>
      )}

      {isChatActive && chatType === 'static-box' && (
        <motion.div
          className="chat-avatars"
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        >
          <div className="avatar avatar1">
            <img src={assistantAvatar1} alt="Assistant 1" />
          </div>
          <div className="avatar avatar-next">
            <img src={liveAvatarSrc} alt="Assistant 2" />
          </div>
          <div
            className={`avatar avatar-next bot ${aiAssistantImage ? 'has-ai-avatar' : ''}`}
            style={aiAssistantImage ? { backgroundImage: `url(${aiAssistantImage})` } : undefined}
          ></div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ChatAvatars;
